import React from 'react';

const TestEnvironmentLabel = () => {
  const currentUrl = window.location.href;
  const isTestEnvironment = currentUrl.includes('baas.develop.higher.systems') || 
                            currentUrl.includes('baas.staging.higher.systems');
  
  if (!isTestEnvironment) {
    return null;
  }

  const labelStyle = {
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    backgroundColor: 'red',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '10px',
    fontSize: '14px',
    zIndex: 1000,
  };

  return <div style={labelStyle}>ambiente de testes</div>;
};

export default TestEnvironmentLabel;